<template>
  <div class="top-ten-banks p-3">
    <h4>Top 10 banks by reported amount in FinCEN Files</h4>
    <p class="mb-0">Total amount diclosed by banks in suspicious activity reports found in the FinCEN Files.</p>
    <stacked-bar-chart :data="data" x-axis-tick-format="$,.0f" label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Source: FinCEN Files data</p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network. The 1,878 SARs in this data cover transactions between 1999 and 2017.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'TopTenBanks',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Deutsche Bank', value: 1310771379656 },
        { label: 'JPMorgan', value: 514206745666 },
        { label: 'Standard Chartered', value: 166139835277 },
        { label: 'Bank of New York Mellon', value: 64109417780 },
        { label: 'Barclays', value: 21677582233 },
        { label: 'Société Générale', value: 8485904902 },
        { label: 'HSBC', value: 4480002672 },
        { label: 'State Street Corporation', value: 2038159735 },
        { label: 'Commerzbank AG', value: 1768874172 },
        { label: 'China Investment Corporation', value: 1334387826 }
      ]
    }
  }
}
</script>
